import { combineReducers } from 'redux'
import keyBy from 'lodash/keyBy'
import FETCH_STATUS from './utils/fetchStatus'
import PRODUCT from './product/productTypes'
import MENU from './menu/menuTypes'
import { createMultipleLifeCycleConstants } from './utils/reducerHelpers'

const PRODUCT_ACTIONS = createMultipleLifeCycleConstants(PRODUCT)
const MENU_ACTIONS = createMultipleLifeCycleConstants(MENU)

const byIdObject = (state = {}, action = {}) => {
  const { type, payload = {} } = action
  const { elementId, menu } = payload || {}
  switch (type) {
    case MENU_ACTIONS.fetchMenuElement.success:
      return {
        ...state,
        [elementId]: menu,
      }
    default:
      return state;
  }
};

const productBySku = (state = {}, action) => {
  const { type, payload = {} } = action
  const { product, products } = payload || {}
  switch (type) {
    case PRODUCT_ACTIONS.fetchProductElement.success:
      return {
        ...state,
        [product.sku]: product,
      }
    case PRODUCT_ACTIONS.fetchProductSlider.success:
      return {
        ...state,
        ...keyBy(products, 'sku'),
      }
    default:
      return state
  }
}

const createByKey = (array, callback) => (
  array.reduce((result, current) => ({
    ...result,
    ...callback(current),
  }), {})
)

const fetchStatusBySku = (state = {}, action) => {
  const { type, payload = {} } = action
  const { skuList, sku } = payload || {}
  switch (type) {
    case PRODUCT_ACTIONS.fetchProductElement.request:
      return {
        ...state,
        [sku]: FETCH_STATUS.REQUEST,
      }
    case PRODUCT_ACTIONS.fetchProductElement.success:
      return {
        ...state,
        [sku]: FETCH_STATUS.SUCCESS,
      }
    case PRODUCT_ACTIONS.fetchProductElement.failure:
      return {
        ...state,
        [sku]: FETCH_STATUS.FAILURE,
      }
    case PRODUCT_ACTIONS.fetchProductSlider.request:
      return {
        ...state,
        ...createByKey(skuList, (productSku) => ({ [productSku]: FETCH_STATUS.REQUEST })),
      }
    case PRODUCT_ACTIONS.fetchProductSlider.success:
      return {
        ...state,
        ...createByKey(skuList, (productSku) => ({ [productSku]: FETCH_STATUS.SUCCESS })),
      }
    case PRODUCT_ACTIONS.fetchProductSlider.failure:
      return {
        ...state,
        ...createByKey(skuList, (productSku) => ({ [productSku]: FETCH_STATUS.FAILURE })),
      }
    default:
      return state
  }
}

const fetchStatus = (state = {}, action = {}) => {
  const { type, payload = {} } = action
  const { elementId } = payload || {}
  switch (type) {
    case MENU_ACTIONS.fetchMenuElement.request:
      return {
        ...state,
        [elementId]: FETCH_STATUS.REQUEST,
      }
    case MENU_ACTIONS.fetchMenuElement.success:
      return {
        ...state,
        [elementId]: FETCH_STATUS.SUCCESS,
      }
    case MENU_ACTIONS.fetchMenuElement.failure:
      return {
        ...state,
        [elementId]: FETCH_STATUS.FAILURE,
      }
    default:
      return state;
  }
};

export default combineReducers({
  byIdObject,
  productBySku,
  fetchStatusBySku,
  fetchStatus,
})



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/elementReducer.js